import Vue from 'vue';
import App from './App.vue';
import Vuetify from 'vuetify';
import router from '@/router';
import store from '@/store';
import Vuex from 'vuex';
import '@/plugins/axios';
import '@/plugins/templates';
import '@mdi/font/css/materialdesignicons.css';
export const eventBus = new Vue();

import '@/style/theme.css';

import _ from 'lodash';
Vue.use(_);

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
Vue.component('VueSlider', VueSlider);

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
});

new Vue({
  router,
  store,
  vuetify : new Vuetify(),
  render: h => h(App),
}).$mount('#app')
